<script setup>
  const props = defineProps({
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    transparent: Boolean,
    fullHeight: Boolean
  });
</script>

<template>
  <div :class="`pge-content-block ${props.transparent ? 'transparent' : ''}`">
    <div class="pge-cb-h-container" :style="[props.title ? 'gap: 12px' : 'gap: 0', props.fullHeight ? 'height: 100%' : '']">
      <div class="pge-cb-h-title-header">
        <div class="pge-cb-h-title">{{ props.title }}</div>
        <div v-if="$slots.headerMore" class="pge-cb-h-header-more">
          <slot name="headerMore"></slot>
        </div>
      </div>
      <div class="pge-cb-h-line"></div>
      <div class="pge-cb-h-subtitle">
        <span>{{props.subtitle}}</span>
      </div>
      <div class="pge-cb-content" :style="props.fullHeight ? 'margin: auto;' : ''">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style>
@import url("./styles/pge-content-block/index.css");
</style>